import * as contentTypeParser from 'content-type';
import mime from 'mime/lite';

import { extname } from './helpers';

export const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

/**
 * ZIP
 */
export const ZIP_MIME_TYPES = [
    'application/zip',
    'application/x-zip',
    'application/x-zip-compressed',
    'application/x-zip-archive',
    'application/x-compressed',
];

export const ZIP_FILE_EXTENSIONS = ['.zip'];

/**
 * DOCX
 */
export const DOCX_MIME_TYPES = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const DOCX_FILE_EXTENSIONS = ['.docx'];

/**
 * Markdown
 */
export const MARKDOWN_MIME_TYPES = ['text/markdown', 'text/x-markdown'];

export const MARKDOWN_FILE_EXTENSIONS = ['.md', '.markdown'];

/**
 * HTML
 */
export const HTML_MIME_TYPES = ['text/html'];

export const HTML_FILE_EXTENSIONS = ['.html'];

/**
 * CSV
 */
export const CSV_MIME_TYPES = ['text/csv', 'text/plain', 'application/vnd.ms-excel', 'text/x-csv'];

export const CSV_FILE_EXTENSIONS = ['.csv'];

/**
 * Normalize a content type to strip the charset and normalize deprecated types.
 */
export function normalizeContentType(contentType: string): string {
    const parsed = contentTypeParser.parse(contentType);

    for (const mimeTypes of [
        ZIP_MIME_TYPES,
        DOCX_MIME_TYPES,
        MARKDOWN_MIME_TYPES,
        HTML_MIME_TYPES,
    ]) {
        if (mimeTypes.includes(parsed.type) && mimeTypes[0]) {
            return mimeTypes[0];
        }
    }

    return parsed.type;
}

/**
 * Get content type of a file using its extension.
 */
export function getContentTypeFromPath(pathname: string): string {
    return normalizeContentType(mime.getType(extname(pathname)) || DEFAULT_CONTENT_TYPE);
}

/**
 * Get content type of a url using its extension.
 */
export function getContentTypeFromURL(uri: string): string {
    const url = new URL(uri);
    return getContentTypeFromPath(url.pathname);
}

/**
 * Get extension from a content type.
 */
export function getExtensionForContentType(type: string, defaultExt = 'bin'): string {
    return mime.getExtension(type) || defaultExt;
}
